/* 点击埋点 */
import HTTP from '@/request/index'
export default {
  inserted: function (el, binding) {
    el.addEventListener(
      'click',
      () => {
        let eventk =
          (el.attributes['data-click-buried'] &&
            el.attributes['data-click-buried'].value) ||
          ''
        let eventv =
          (el.attributes['data-click-eventv'] &&
            el.attributes['data-click-eventv'].value) ||
          ''
        let list = eventk.split(',')
        list.map((item) => {
          if (item) {
            HTTP.bindH5UMA(item, eventv)
          }
        })
      },
      true
    )
  }
}
